
import {
    Grid,
    Button,
    Typography,
    Paper
} from "@material-ui/core";
import React from 'react'
import DynamicTable from "./DynamicTable";
import { addressTableHeader } from './constants'


const AddressTable = ({ emp, onClick }) => {
    let table = {
        header: addressTableHeader,
        rows: [
            [
                emp?.id,
                emp?.address,
                emp?.address1,
                `${emp?.city},${emp?.state}`,
                emp?.zip,
                <Button onClick={() => onClick()} className="EditIcon"></Button>
            ]
        ]
    }
    return (
        <Grid xs={12} className=" ">
            <Grid xs={12} className=" mb14">

                <DynamicTable tableData={table} />
            </Grid>
            <Paper>

            </Paper>
        </Grid>
    )
}

export default AddressTable